import { ExtractedField } from '~/components/ui/document/dialogs/documentOverviewDialog/ExtractedField';
import { TabHeader } from '~/components/ui/document/TabHeader';

export function DocumentOverviewSidebar(props: {
  documentId: string;
  activeTab: TabName;
  setTab: (t: TabName) => void;
  values: {
    id: string;
    name: string;
    value: string;
  }[];
  scrollToField: (v: string) => void;
  showActions: boolean;
  // deleteField: DeleteFieldFn;
}) {
  // const handleDeleteField = (fieldId: string) => {
  //   props.deleteField(fieldId, props.activeTab, props.documentId);
  // };
  return (
    <div className="sidebar">
      <div className="sidebarheader">
        <TabHeader
          tab="fields"
          activeTab={props.activeTab}
          setTab={props.setTab}
        />
        <TabHeader
          tab="clauses"
          activeTab={props.activeTab}
          setTab={props.setTab}
        />
      </div>

      <div className="fields">
        {props.values.length ? (
          props.values.map(({ id, name, value }) => (
            <ExtractedField
              // deleteField={(fieldId) => handleDeleteField(fieldId)}
              key={id}
              documentId={props.documentId}
              fieldId={id}
              fieldValue={value}
              fieldName={name}
              scrollToField={props.scrollToField}
              showActions={props.showActions}
              type={props.activeTab}
            />
          ))
        ) : (
          <span className="flex justify-content-center pt-3">
            No extracted {props.activeTab} found
          </span>
        )}
      </div>
    </div>
  );
}
